import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { DetailedVehicle } from '../../../@types/detailed-vehicle';
import type Item from '../../../@types/item';
import type { Tree, Category as TreeCategory } from '../../../@types/vehicle-properties';
import Content from '../../../styled-components/components/Content';
import { H3 } from '../../../styled-components/components/Heading';
import { StackMedium } from '../../../styled-components/components/Stack';
import { size } from '../../../styled-components/layout/helpers';
import CategoriesTabs from './CategoriesTabs';
import Category from './category';
import PropertiesModal, { ModalContext } from './properties-modal';

const PropertiesWrapper = styled.div.withConfig({ componentId: 'sc-mmqan3-0' })`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: ${size(2)};
`;

interface IProps {
  displayModal: boolean;
  modalTitle: string;
  modalText: string;
  item: DetailedVehicle | Item;
  propertyTree: Tree;
  activeCategory: TreeCategory | undefined;
  activeCategoryId: number;
  headInfo?: boolean;
  disblePropertyLinks?: boolean;
  setCategory: (arg0: number) => void;
  setDisplayModal: (arg0: boolean) => void;
  setModalTitle: (arg0: string) => void;
  setModalText: (arg0: string) => void;
}

const Base = ({
  displayModal,
  modalTitle,
  modalText,
  propertyTree,
  activeCategory,
  activeCategoryId,
  setCategory,
  setDisplayModal,
  setModalTitle,
  setModalText,
  item,
  disblePropertyLinks,
  headInfo = true,
}: IProps) => {
  const { t } = useTranslation('item');
  return (
    <div className="item-section">
      {headInfo && (
        <StackMedium>
          <H3 as="h2" $margin="small">
            {t('Car details', { ns: 'item' })}
          </H3>
          <Content>
            <p>{t('Information from the manufacturer', { ns: 'item' })}</p>
          </Content>
        </StackMedium>
      )}
      <ModalContext.Provider
        value={{
          setDisplayModal,
          setModalTitle,
          setModalText,
        }}
      >
        <StackMedium>
          <PropertiesWrapper>
            <CategoriesTabs
              propertyTree={propertyTree}
              activeCategoryId={activeCategoryId}
              setCategory={setCategory}
            />
            <Category
              activeCategoryId={activeCategoryId}
              propertyTree={propertyTree}
              category={activeCategory}
              item={item}
              disblePropertyLinks={disblePropertyLinks}
            />
          </PropertiesWrapper>
        </StackMedium>
      </ModalContext.Provider>
      {displayModal && (
        <PropertiesModal
          title={modalTitle}
          text={modalText}
          onClose={(): void => setDisplayModal(false)}
        />
      )}
    </div>
  );
};

export default Base;
